<template>
  <div class="table-responsive" :class="{ 'border rounded': bordered }">
    <table v-if="displayRows.length || modules.length || routerModelsText" class="table table-sm table-hover mb-0">
      <tbody>
        <tr v-for="row in displayRows" :key="row.label">
          <th :class="labelClass">{{ row.label }}</th>
          <td>{{ formatValue(row.value) }}</td>
        </tr>
        <tr v-if="showEmptyAsNa || routerModelsText">
          <th :class="labelClass">Router Models</th>
          <td>{{ formatValue(routerModelsText) }}</td>
        </tr>
        <tr v-if="showEmptyAsNa || modules.length">
          <th :class="labelClass">Modules</th>
          <td>
            <template v-if="modules.length">
              <span
                v-for="(item, index) in modules"
                :key="index"
                class="badge bg-info me-1 mb-1"
              >{{ item }}</span>
            </template>
            <template v-else>N/A</template>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="text-muted py-3 text-center">N/A</div>
  </div>
</template>

<script>
export default {
  name: 'LicenseSummaryTable',
  props: {
    licenseInfo: {
      type: Object,
      default: null,
    },
    device: {
      type: Object,
      default: null,
    },
    bordered: {
      type: Boolean,
      default: true,
    },
    labelClass: {
      type: String,
      default: '',
    },
    includeDeviceType: {
      type: Boolean,
      default: false,
    },
    /** When true, empty fields render as N/A instead of being hidden */
    showEmptyAsNa: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    license() {
      return this.licenseInfo || {}
    },
    deviceData() {
      return this.device || {}
    },
    locationText() {
      return [this.license.city, this.license.country].filter(Boolean).join(', ')
    },
    modules() {
      return Array.isArray(this.license.modules) ? this.license.modules : []
    },
    routerModelsText() {
      if (!Array.isArray(this.license.routerModels) || !this.license.routerModels.length) {
        return ''
      }
      return this.license.routerModels.join(', ')
    },
    scalarRows() {
      const license = this.license
      const device = this.deviceData
      const rows = [
        { label: 'Account Number', value: license.accountNumber || device.accountNumber },
        { label: 'Registered For', value: license.registeredFor || device.registeredFor },
        { label: 'Product', value: license.product },
        { label: 'Product Version', value: license.productVersion },
        { label: 'Gateway Device', value: license.gatewayDevice },
        { label: 'License ID', value: license.licenseId },
        { label: 'Setup PIN', value: license.pin },
        { label: 'Description', value: license.description || device.description3 },
        { label: 'Remarks', value: license.remarks || device.description2 },
        { label: 'License Duration', value: license.licensePeriodDisplay },
        { label: 'Licensed Users', value: license.licensedUsersDisplay },
        { label: 'Started At', value: license.startedAt },
        { label: 'Expiration', value: license.expiresAt },
        { label: 'Used', value: license.used },
        { label: 'Deactivated', value: license.deactivated },
        { label: 'Hostname', value: license.hostname },
        { label: 'VPN', value: license.vpn },
        { label: 'IP', value: license.ip },
        { label: 'Project Ownership', value: license.projectOwnership },
        { label: 'UUID', value: license.applied },
        { label: 'Created At', value: license.createdAt },
        { label: 'Updated At', value: license.updatedAt },
        { label: 'Location', value: this.locationText },
      ]

      if (this.includeDeviceType) {
        rows.splice(4, 0, { label: 'Device Type', value: device.deviceType })
      }

      return rows
    },
    displayRows() {
      if (this.showEmptyAsNa) {
        return this.scalarRows
      }
      return this.scalarRows.filter((row) => row.value != null && String(row.value).trim() !== '')
    },
    hasContent() {
      return this.displayRows.some((row) => row.value != null && String(row.value).trim() !== '')
        || this.routerModelsText
        || this.modules.length > 0
    },
  },
  methods: {
    formatValue(value) {
      if (value == null || String(value).trim() === '') {
        return this.showEmptyAsNa ? 'N/A' : ''
      }
      return value
    },
  },
}
</script>
